import {BaseApi, RequireAuthApi} from '@/api/base.api';
import {TimelineReplyModel} from '@/models/timeline.model';

export class TimelineReplyApi extends BaseApi<TimelineReplyModel> {

  constructor(protected challengeId: number, protected timelineId: number, protected interactionId: number) {
    super(`/challenges/${challengeId}/timelines/${timelineId}/interactions/${interactionId}/replies`, [
      RequireAuthApi.ALL,
      RequireAuthApi.CREATE,
      RequireAuthApi.UPDATE,
      RequireAuthApi.DESTROY,
    ]);
  }
}
